<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsTextField v-model="tableData.filters.name" :label="$LANG.Get('fields.name')"></NevsTextField>
                <NevsSelect :nullable="true" v-model="tableData.filters.customer_id" :ajax="'select/customers'"
                            :label="$LANG.Get('fields.customer')"
                            @select="filterLabels.customer_id = $event.label"></NevsSelect>
                <NevsSelect :nullable="true" v-model="tableData.filters.contract_id" :ajax="'select/contracts'"
                            :label="$LANG.Get('fields.contract')"
                            @select="filterLabels.contract_id = $event.label"></NevsSelect>
                <NevsSelect v-model="tableData.filters.active" :label="$LANG.Get('fields.activeM')"
                            :options="$HELPERS.GetYesNoAllOptions(this)"></NevsSelect>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">
                        {{ item.name }}
                    </td>
                    <td class="nevs-table-linked-cell short-customer" @click="openClick(item.id)">
                        {{ item.customer_display }}
                    </td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.repeating_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.amount_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.contract_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.active_display }}</td>
                    <td class="nevs-table-actions">
                        <NevsActions :width="'210px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";

export default {
    name: "ModuleAutomaticInvoices",
    components: {NevsTableFilters, NevsActions, NevsSelect, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            eInvoiceModal: {
                show: false,
                invoiceId: null
            },
            tableData: {
                fields: [
                    {
                        name: 'name',
                        label: this.$LANG.Get('fields.name')
                    },
                    {
                        name: 'customer',
                        label: this.$LANG.Get('fields.customer'),
                        sortable: false
                    },
                    {
                        name: 'repeating',
                        label: this.$LANG.Get('fields.repeating'),
                        sortable: false
                    },
                    {
                        name: 'amount',
                        label: this.$LANG.Get('labels.amount')
                    },
                    {
                        name: 'contract',
                        label: this.$LANG.Get('fields.contract'),
                        sortable: false
                    },
                    {
                        name: 'active',
                        label: this.$LANG.Get('fields.activeM')
                    },
                    {
                        name: 'actions',
                        width: '210px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    name: '',
                    customer_id: null,
                    contract_id: null,
                    active: 1
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'id',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.openInNewWindow'),
                    action: (item) => {
                        this.openClick(item.id, true);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.copy'),
                    action: (item) => {
                        this.copyClick(item.id);
                    },
                    visible: (item) => {
                        return item.invoice_status_id !== 5;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.createInvoiceNow'),
                    action: (item) => {
                        this.createInvoiceNowClick(item);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.delete'),
                    action: (item) => {
                        this.deleteClick(item);
                    },
                    visible: (item) => {
                        return item.deletable;
                    }
                }
            ],
            // Labels of the select filters, for the collapsed filter panel's summary. v-model only
            // carries the id, so the label is captured from NevsSelect's `select` event.
            filterLabels: {
                customer_id: '',
                contract_id: ''
            },
            crossTabHandle: null
        }
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed
        // here and the panel picks the active ones.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'name',
                    label: this.$LANG.Get('fields.name'),
                    value: filters.name
                },
                {
                    name: 'customer_id',
                    label: this.$LANG.Get('fields.customer'),
                    value: filters.customer_id === null ? '' : this.filterLabels.customer_id
                },
                {
                    name: 'contract_id',
                    label: this.$LANG.Get('fields.contract'),
                    value: filters.contract_id === null ? '' : this.filterLabels.contract_id
                },
                {
                    name: 'active',
                    label: this.$LANG.Get('fields.activeM'),
                    value: filters.active === -1 ? '' : this.$LANG.Get(filters.active === 1 ? 'options.yes' : 'options.no')
                }
            ];
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        deleteClick(invoice) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'automatic-invoices/' + invoice.id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-automatic-invoices', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                name: '',
                customer_id: null,
                contract_id: null,
                active: -1
            };
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.calculateTableHeight();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'automatic-invoices/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        createInvoiceNowClick(item) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.createInvoiceNowQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('post', 'automatic-invoices/create-invoice/' + item.id, {}, (data, success) => {
                            if (success) {
                                vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.invoiceCreated')});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        copyClick(id) {
            this.$router.push('/automatic-invoices/' + id + '/copy');
        },
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/automatic-invoices/' + id + '/edit');
                window.open(routeData.href);
            } else {
                this.$router.push('/automatic-invoices/' + id + '/edit');
            }
        },
        addClick() {
            this.$router.push('/automatic-invoices/0/add');
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'automatic-invoices', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                    vm.$nextTick(() => {
                        vm.calculateTableHeight();
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.calculateTableHeight();
        },
        calculateTableHeight() {
            let offset = 205;
            if (this.hasDisclaimers) offset = 255;
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'automatic-invoices');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.automaticInvoices'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-automatic-invoices', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}

@media only screen and (max-width: 1920px) and (-webkit-device-pixel-ratio: 1.25) {
    .short-customer {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: anywhere;
    }
}
</style>